import { useQuery } from '@tanstack/react-query';
import { getActiveImportInvalid } from 'config/requests/bankOperations';
import { PENDING_STATUSES } from 'shared/widgets/RequestsBankOpsImport/constants/importFileStatuses';
import { ACTIVE_IMPORT_ID_KEY } from 'shared/widgets/RequestsBankOpsImport/hooks/useGetActiveImportId';
import { ImportFileStatuses, ImportFileStatusesValue } from 'types/embedded/bankOperation';

export const ACTIVE_IMPORT_INVALID_KEY = 'invalid';

const REFETCH_INTERVAL = 5000;

export const useGetActiveImportInvalid = (
  id: string | undefined,
  status: ImportFileStatusesValue | undefined,
) => {
  const { data, isLoading, isFetching } = useQuery({
    queryKey: [ACTIVE_IMPORT_ID_KEY, id, ACTIVE_IMPORT_INVALID_KEY, status],
    queryFn: () => getActiveImportInvalid(id!),
    refetchInterval:
      status && PENDING_STATUSES.includes(status as ImportFileStatuses) ? REFETCH_INTERVAL : false,
    enabled: Boolean(id),
  });

  return { data, isLoading, isFetching };
};
